<template>
  <div>
    <app-header :name="$t('partners.partners')" :show-arrow-back="false" />
  </div>
  <div class="filter_parent SPC-MT-400">
    <v-row>
      <v-col cols="4" class="">
        <app-search-field
          @search-event="fetchAgain(1)"
          @search-function="searchPartners"
          @filter-event="filterPartners"
          :callback="true"
        />
      </v-col>
      <v-col cols="4" class="">
        <app-select-field
          class="px-2"
          :options="countryOptions"
          :label="$t('projects.countries')"
          placeholder="All"
          v-model="country"
        />
      </v-col>
    </v-row>
    <div class="SPC-MT-400">
      <app-table
        :showEditPage="true"
        :isPartners="true"
        :headers="headers"
        :items="isAllPartners"
        :showCheck="canEdit"
        :hideMenu="!canEdit"
        :updateCallback="true"
        @proceed-to-update="proceedToUpdate"
        @edit-event="showDialog({ $event, data: 'edit' })"
        @reset-event="showResetPasswordDialog({ $event, data: 'reset' })"
        @delete-event="showDialog({ $event, data: 'delete' })"
        @delete-multiple-event="
          showDeleteMultipleDialog({ $event, data: 'multiple' })
        "
      >
        <template #title>
          <h3 class="H500">{{ $t("partners.allPartners") }}</h3>
        </template>
        <template #actions v-if="canEdit">
          <app-primary-button
            :buttonLabel="$t('partners.addPartners')"
            @click="addPartner"
          >
            <template #icon>
              <v-icon icon="mdi-plus"></v-icon>
            </template>
          </app-primary-button>
        </template>
        <template #footer>
          <div>
            <Paginator
              :total-items="totalPages"
              v-model="currentPages"
              :items-per-page="10"
              :max-pages-shown="5"
              :on-click="loadMore"
            />
          </div>
        </template>
      </app-table>
    </div>
    <!-- dialog for deleting and deactivating user -->
    <app-dialog
      ref="dialog"
      :title="title"
      :subtitle="subTitle"
      height="302"
      width="408"
    >
      <template #actions>
        <v-row class="mb-5 mt-1 px-4">
          <v-col cols="6" class="">
            <app-secondary-button
              :buttonLabel="$t('employees.cancel')"
              @click-event="hideDialog()"
            >
            </app-secondary-button>
          </v-col>
          <v-col cols="6" class="">
            <v-btn
              variant="default"
              min-width="100%"
              min-height="100%"
              class="bg-[#D92D20] text-white !normal-case rounded-lg font-['Open_Sans'] text-[1rem] font-normal"
              @click="isDelete ? deletePartner() : updatePartnerStatus()"
            >
              <!-- Yes , delete -->
              {{
                isActivate
                  ? $t("employees.activate")
                  : isDelete
                  ? $t("employees.yesDelete")
                  : $t("employees.yesDeactivate")
              }}
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </app-dialog>

    <app-dialog
      ref="deleteMultipleDialog"
      :title="title"
      :subtitle="subTitle"
      height="302"
      width="408"
    >
      <template #actions>
        <v-row class="mb-5 mt-1 px-4">
          <v-col cols="6" class="">
            <app-secondary-button
              :buttonLabel="$t('employees.cancel')"
              @click-event="hidemultipleDelete()"
            >
            </app-secondary-button>
          </v-col>
          <v-col cols="6" class="">
            <v-btn
              variant="default"
              min-width="100%"
              min-height="100%"
              class="bg-[#D92D20] text-white !normal-case rounded-lg font-['Open_Sans'] text-[1rem] font-normal"
              @click="deleteMultiplePartners"
            >
              <!-- Yes , delete -->
              {{ $t("employees.yesDelete") }}
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </app-dialog>
    <app-alert
      :title="$t(getTranslatedStringKey(alertTitle))"
      @close-alert="alertState = false"
      :state="alertState"
      :timeout="5000"
      :type="alertType"
    />
  </div>
</template>
<script>
import { defineComponent } from "vue";
import AppHeader from "@/components/shared/AppHeader.vue";
import Paginator from "@/components/shared/PaginationComponent.vue";
import Api from "@/services/api";
import countries from "@/services/country_api";
import { mapState } from "vuex";
import { getTransString, handleFilterSet } from "@/services/helpers";

export default defineComponent({
  name: "EmployeeLayout",
  components: {
    AppHeader,
    Paginator,
  },
  data() {
    return {
      countryOptions: null,
      headers: ["Company Name", "Email", "Country", "City"],
      loading: false,
      alertType: "success",
      alertState: false,
      alertTitle: "",
      cancelLabel: "Cancel",
      title: "",
      subTitle: "",
      selectedId: "",
      selectedIds: [],
      isEdit: false,
      isDelete: false,
      isActivate: false,
      currentPages: 1,
      isReset: false,
      tableData: [],
      userKey: null,
      userStatus: null,
      research: false,
      newPassword: "",
      confirmPassword: "",
      errorPasswordMessage: "",
      hasPasswordError: false,
      hasConfirmPasswordError: false,
      errorConfirmPassword: "",
      position: "",
      company: "",
      employmentType: "",
      team: "",
      country: "",
    };
  },
  watch: {
    position(...args) {
      this.handleFilterSet("position", args);
    },
    team(...args) {
      this.handleFilterSet("team", args);
    },
    company(...args) {
      this.handleFilterSet("company", args);
    },
    employmentType(...args) {
      this.handleFilterSet("employment_type", args);
    },
    isPositionsTitle(val) {
      this.position = val?.length > 0 ? val[0] : "";
    },
    isTeamsTitle(val) {
      this.team = val?.length > 0 ? val[0] : "";
    },
    isEmploymentTypesTitle(val) {
      this.employmentType = val?.length > 0 ? val[0] : "";
    },
    isCompaniesTitle(val) {
      this.company = val?.length > 0 ? val[0] : "";
    },
    country(...args) {
      handleFilterSet(
        "country",
        args,
        "partnerModules/REMOVE_FILTER_BYS_FROM_STATE",
        "partnerModules/SET_FILTER_BYS_TO_STATE"
      );
    },
  },

  computed: {
    canEdit() {
      const modifiedData = this.$store.getters["auth/canEdit"];
      const findModules = modifiedData.filter(
        (module) => module.module_name === "Partners"
      );
      return findModules?.length !== 0;
    },
    isAllPartners() {
      return this.$store.getters["partnerModules/isAllPartners"];
    },
    isTableHeaders() {
      return this.$store.getters["partnerModules/isTableHeaders"];
    },
    currentPage() {
      return this.$store.getters["partnerModules/isCurrentPage"];
    },
    totalPages() {
      return this.$store.getters["partnerModules/isTotalPages"];
    },
    isCompaniesTitle() {
      const companies =
        this.$store.getters["hrConfigurations/isCompaniesTitle"];
      const allText = this.appLocaleLang === "en" ? "All" : "Alle";
      return [allText, ...companies];
    },
    isPositionsTitle() {
      const positions =
        this.$store.getters["hrConfigurations/isPositionsTitle"];
      const allText = this.appLocaleLang === "en" ? "All" : "Alle";
      return [allText, ...positions];
    },
    isEmploymentTypesTitle() {
      const employmentTypes =
        this.$store.getters["hrConfigurations/isEmploymentTypesTitle"];
      const allText = this.appLocaleLang === "en" ? "All" : "Alle";
      return [allText, ...employmentTypes];
    },
    isTeamsTitle() {
      const teams = this.$store.getters["hrConfigurations/isTeamsTitle"];
      const allText = this.appLocaleLang === "en" ? "All" : "Alle";
      return [allText, ...teams];
    },
    isFilterBys() {
      return this.$store.getters["hrConfigurations/isFilterBys"];
    },
    appLocaleLang() {
      return this.translation.locale;
    },

    ...mapState(["translation"]),
  },

  methods: {
    setResponseData(response) {
      const data = response.data;
      const payloadKeys = {
        company_name: "company name",
      };
      const payload = data.reduce((prev, acc) => {
        const modData = Object.keys(acc).reduce((innerPrev, innerAcc) => {
          if (Object.keys(payloadKeys).includes(innerAcc)) {
            innerPrev[payloadKeys[innerAcc]] = acc[innerAcc];
          } else {
            innerPrev[innerAcc] = acc[innerAcc];
          }
          return innerPrev;
        }, {});
        return [...prev, modData];
      }, []);

      this.$store.commit("partnerModules/SET_PARTNERS_TO_STATE", payload);
      this.$store.commit(
        "partnerModules/SET_CURRENT_PAGE_TO_STATE",
        response.current_page
      );
      this.$store.commit(
        "partnerModules/SET_TOTAL_PAGES_TO_STATE",
        response.total_data
      );
    },
    filterPartners(data) {
      Api()
        .post(`/partners/search-partners/1/`, { filters: data })
        .then((response) => {
          if (response.data.status === "success") {
            // this.headers = response.data.headers;
            this.setResponseData(response.data);
          }
        });
    },
    handleFilterSet(type, args) {
      if (args[0] === "All" || args[0] === "Alle") {
        this.$store.commit("hrResources/REMOVE_FILTER_BYS_FROM_STATE", type);
      } else {
        this.$store.commit("hrResources/SET_FILTER_BYS_TO_STATE", [
          type,
          args[0],
        ]);
      }
    },
    searchPartners(search_query) {
      Api()
        .post(`partners/search-partners/${this.currentPage}/`, { search_query })
        .then((response) => {
          if (response.data.status === "success") {
            // this.headers = response.data.headers;
            this.setResponseData(response.data);
          }
        });
    },
    addPartner() {
      this.$store.commit("partnerModules/SET_EDIT_PARTNER_TO_STATE", false);
      this.$store.commit("partnerModules/SET_PERSONAl_DATA_TO_STATE", null);
      this.$store.commit("partnerModules/SET_PARTNER_KEY_TO_STATE", "");
      this.$store.commit("partnerModules/SET_CURRENT_TAB_TO_STATE", 0);
      this.$router.push({ name: "addPartner" });
    },
    getFiltersData(fields) {
      return this.isTableHeaders?.reduce((acc, curr) => {
        if (fields.includes(curr)) return [...acc, { id: curr, value: curr }];
        else return acc;
      }, []);
    },
    hideError() {
      this.hasConfirmPasswordError = false;
      this.errorConfirmPassword = "";
      this.hasPasswordError = false;
      this.errorPasswordMessage = "";
    },
    showDialog(data) {
      this.selectedId = data?.$event?.id;
      this.userStatus = !data?.$event?.is_active;
      if (data.data === "edit") {
        if (data?.$event?.is_active === false) {
          this.title = "employees.activate";
          this.subTitle = "employees.activatingThis";
          this.isEdit = !this.isEdit;
          this.isActivate = true;
          this.cancelLabel = "employees.noKeepIt";
          this.$refs.dialog.showDialog = true;
        } else {
          this.title = "employees.deactivateAccount";
          this.isActivate = false;
          this.subTitle = "employees.deactivatingThis";
          this.isEdit = !this.isEdit;
          this.cancelLabel = "employees.noKeepIt";
          this.$refs.dialog.showDialog = true;
        }
      } else {
        this.subTitle = "partners.areYouSure";
        this.title = "partners.deletePartners";
        this.isDelete = !this.isDelete;
        this.cancelLabel = "employees.noKeepIt";
        this.$refs.dialog.showDialog = true;
        this.isActivate = false;
      }
    },
    showDeleteMultipleDialog(data) {
      if (data.data === "multiple") {
        this.selectedIds = data?.$event;
        this.subTitle = "partners.areYouSure";
        this.title = "partners.deletePartners";
        // this.isDelete = !this.isDelete;
        this.cancelLabel = "employees.noKeepIt";
        this.$refs.deleteMultipleDialog.showDialog = true;
      }
    },
    hideDialog() {
      this.$refs.dialog.showDialog = false;
      setTimeout(() => {
        this.isEdit = false;
        this.isDelete = false;
        this.isActivate = false;
        this.addTitle = "";
        this.subTitle = "";
        this.buttonLabel = "employees.add";
        this.cancelLabel = "employees.cancel";
      }, 600);
    },
    hidemultipleDelete() {
      this.$refs.deleteMultipleDialog.showDialog = false;
      setTimeout(() => {
        this.isEdit = false;
        this.isDelete = false;
        this.isActivate = false;
        this.addTitle = "";
        this.subTitle = "";
        this.buttonLabel = "employees.add";
        this.cancelLabel = "employees.cancel";
      }, 600);
    },
    fetchAgain(page) {
      // const page = this.currentPage + 1;
      this.getAllPartners(page);
    },
    getTranslatedStringKey(field) {
      return getTransString(field);
    },
    getCountryByName() {
      const countryArray = [];
      for (const country of countries) {
        countryArray.push(country.name);
      }
      return countryArray;
    },
    getAllPartners(page) {
      Api()
        .get(`/partners/get-all-partners/${page}/`)
        .then((response) => {
          if (response.data.status === "success") {
            this.setResponseData(response.data);
          }
        });
    },
    updatePartnerStatus() {
      const payload = {
        status: this.userStatus,
      };
      Api()
        .patch(`/partners/update-partner-status/${this.selectedId}/`, payload)
        .then((response) => {
          if (response.data.status === "success") {
            this.alertState = !this.alertState;
            this.alertTitle = response.data.detail;
            this.getAllPartners(this.currentPage);
            this.$refs.dialog.showDialog = false;
            setTimeout(() => {
              this.addTitle = "";
              this.subTitle = "";
              this.isEdit = !this.isEdit;
            }, 600);
          }
          if (response.data.status === "error") {
            this.isEdit = !this.isEdit;
            this.$refs.dialog.showDialog = false;
            this.addTitle = "";
            this.alertType = "error";
            this.alertTitle = response.data.detail;
            this.alertState = !this.alertState;
          }
        })
        .catch((error) => {
          if (error) {
            this.$refs.dialog.showDialog = false;
            this.alertType = "error";
            this.alertTitle = error.response.data.detail;
            this.alertState = !this.alertState;
          }
        });
    },
    deletePartner() {
      Api()
        .delete(`partners/delete-partner/${this.selectedId}`)
        .then((response) => {
          if (response.data.status === "success") {
            this.alertState = !this.alertState;
            this.alertTitle = response.data.detail;
            this.getAllPartners(this.currentPage);
            this.$refs.dialog.showDialog = false;
            setTimeout(() => {
              this.isDelete = !this.isDelete;
            }, 600);
          }
          if (response.data.status === "error") {
            this.isDelete = !this.isDelete;
            this.$refs.dialog.showDialog = false;
            this.addTitle = "";
            this.alertType = "error";
            this.alertTitle = response.data.detail;
            this.alertState = !this.alertState;
          }
        })
        .catch((error) => {
          if (error) {
            this.isDelete = !this.isDelete;
            this.$refs.dialog.showDialog = false;
            this.alertType = "error";
            this.alertTitle = error.response.data.detail;
            this.alertState = !this.alertState;
          }
        });
    },
    deleteMultiplePartners() {
      const payload = {
        partners_ids: this.selectedIds,
      };

      Api()
        .post("/partners/delete-multiple-partners/", payload)
        .then((response) => {
          if (response.data.status === "success") {
            this.alertState = !this.alertState;
            this.alertTitle = response.data.detail;
            this.getAllPartners(this.currentPage);
            this.$refs.deleteMultipleDialog.showDialog = false;
            setTimeout(() => {
              this.addTitle = "";
              this.subTitle = "";
            }, 1000);
          }
          if (response.data.status === "error") {
            this.$refs.deleteMultipleDialog.showDialog = false;
            this.addTitle = "";
            this.alertType = "error";
            this.alertTitle = response.data.detail;
            this.alertState = !this.alertState;
          }
        })
        .catch((error) => {
          if (error) {
            this.$refs.deleteMultipleDialog.showDialog = false;
            this.addTitle = "";
            this.subTitle = "";
            this.alertType = "error";
            this.alertTitle = error.response.data.detail;
            this.alertState = !this.alertState;
          }
        });
    },
    proceedToUpdate(item) {
      this.$store.commit("partnerModules/SET_PARTNER_KEY_TO_STATE", item.id);
      this.$store.commit("partnerModules/SET_PERSONAl_DATA_TO_STATE", item);
    },
    loadMore() {
      let page = this.currentPages;
      this.getAllPartners(page);
    },
  },
  created() {
    this.getAllPartners(this.currentPage);
    this.countryOptions = this.getCountryByName();
    this.$store.commit("projectModules/SET_PROJECT_PAGE_TO_STATE", false);
  },
});
</script>

<style scoped>
label {
  color: #344054;
}
</style>
